import FilterButtonGroup from './src/filter-button-group.vue';

FilterButtonGroup.install = function (Vue) {
  Vue.component(FilterButtonGroup.name, FilterButtonGroup);
};

export default FilterButtonGroup;
